
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlS as ObiOwnShipControlSElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-s.js';
 
 
 

 
 export const ObiOwnShipControlS = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-s',
   elementClass: ObiOwnShipControlSElement,
   events: {
     
   }
  });
 
 